<template>
  <div>
    <back-header :head-title="title"></back-header>
    <div class="login">
      <div class="title">账号登录</div>
      <div class="form_box">
        <div class="phone_box form">
          <input type="text" v-model="account" placeholder="账号/手机号" />
        </div>
        <div class="password_box form">
          <div class="left_area">
            <input 
            :type="[showPassword?'text':'password']" 
            v-model="password" placeholder="请输入密码" />
          </div>
          
          <section class="icon_input button_switch" @click="changePassWordType">
            <img v-show="!showPassword" src="~assets/images/index/close-code.png" alt />
            <img v-show="showPassword" src="~assets/images/index/open-code.png" alt />
          </section>
        </div>
      </div>
      <div class="login_btn" @click="login">登录</div>
      <div class="register" @click="goRegister">没有账号？去注册</div>
    </div>
  </div>
</template>

<script>
import backHeader from "components/header/backHeader";
import user from "assets/commonjs/userInfo";
import {toast} from 'assets/commonjs/toast';
import Utils from "assets/commonjs/tool";
export default {
  data() {
    return {
      account: "",
      password: "",
      title: "登录",
      mobilePhonePrefix: 86,
      companyId: 1,
      userType: 1,
      showPassword:false,
      registerUrl:process.env.VUE_APP_REG_URL
    };
  },
  components: { backHeader },
  methods: {
    login() {
      /**
       * 81015540 // ct170424
       */
      let accountValue = this.account.trim(),
        data;
      //用户填的是账号
      if (this.judgeLength(accountValue)) {
        data = {
          customerNumber: this.account,
          password: this.password
        };
      } else {
        //用户填的是手机号码
        data = {
          mobilePhonePrefix: this.mobilePhonePrefix,
          mobilePhone: this.account,
          password: this.password
        };
      }
      let userIpinfo = Utils.userIpInfo()  
      this.$api.strageList.login(data).then(res => {
        if (res.data && res.data.code == 200) {
          user.getUserInfo(res.data.ch_msg[0],"login",userIpinfo);
          
        }else{
          toast(res.data.code_desc)
        }
      });
    },
    judgeLength: function(value) {
      if (value.length === 8) {
        return true;
      } else {
        return false;
      }
    },
    //密码隐藏显示切换
        changePassWordType:function(){
            this.showPassword = !this.showPassword;
            this.type = "text"
        },
        goRegister(){
          window.location.href = this.registerUrl
        }
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
.login {
  padding: 0 0.85rem;
  .title {
    @include sc(0.5rem, #333);
    font-weight: bold;
    margin-bottom: 1.59rem;
    margin-top: 1.5rem;
  }
  .form {
    border-bottom: 0.025rem solid #dddddd;
    padding-bottom: 0.22rem;
    font-size: 0;
    position: relative;
  }
  .form_box {
    input {
      font-size: 0.3rem;
      color: #333;
      padding-left: 0.86rem;
    }
    .phone_box {
      margin-bottom: 0.4rem;
      &:before {
        content: "";
        @include wh(0.24rem, 0.28rem);
        background-image: url("~assets/images/icon-sprite.png");
        background-repeat: no-repeat;
        background-position: -1.04rem -2.44rem;
        background-size: 3.34rem 3.2rem;
        position: absolute;
        top: 0.1rem;
        left: 0.3rem;
      }
    }
    .password_box {
      @include fj();
      &:before {
        content: "";
        @include wh(0.24rem, 0.28rem);
        background-image: url("~assets/images/icon-sprite.png");
        background-repeat: no-repeat;
        background-position: -0.6rem -2.44rem;
        background-size: 3.34rem 3.2rem;
        position: absolute;
        top: 0.1rem;
        left: 0.3rem;
      }
    }
  }
}
.login_btn {
  @include wh(5.8rem, 0.9rem);
  line-height: 0.9rem;
  border-radius: 0.06rem;
  text-align: center;
  margin-top: 0.7rem;
  background: rgba(10, 149, 255, 1);
  @include sc(0.32rem, #fff);
}
.icon_input{
  img{
    @include wh(.44rem,.44rem)
  }
}
.register{
  @include sc(.24rem,#999);
  text-align: center;
  margin-top:.1rem;
}
</style>